// extracted by mini-css-extract-plugin
export default {"container":"loading_container_container__4DErw","overlayText":"loading_container_overlayText__-u7Pc"};